"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = void 0;
var accounting_js_1 = require("accounting-js");
/**
 * Formats a given `Number` as a currency string, based on the provided `CurrencyFormatOptions`.
 * Wrapper for accounting-js `formatMoney` (http://openexchangerates.github.io/accounting.js/#methods).
 *
 * @hidden
 * @param value The `Number` value to be formatted.
 * @param options The currency format options to be used.
 * @returns The formatted currency string.
 */
var formatCurrency = function (value, options) {
    var nonNumberPlaceholder = options.nonNumberPlaceholder, symbol = options.symbol, format = options.format, decimalPrecision = options.decimalPrecision, thousandsSeparator = options.thousandsSeparator, decimalSeparator = options.decimalSeparator;
    if (value == null)
        return nonNumberPlaceholder;
    else if (isNaN(value))
        throw new Error("formatCurrency - received a non numerically assigned value: " + value);
    var currencySettings = {
        symbol: symbol,
        format: format,
        precision: decimalPrecision,
        thousand: thousandsSeparator,
        decimal: decimalSeparator
    };
    return accounting_js_1.formatMoney(value, currencySettings);
};
exports.formatCurrency = formatCurrency;
//# sourceMappingURL=format-currency.js.map